/*
 * @@Author: MuYang
 */

// 头部
export const header = {
  handle (node, {buttonMap, info}) {
    node.props.title = info.title
    // node.props.positionCeiling = true   layout_type_polymeric_create
    node.buttons = !(info.type === 'layout_type_update' || info.type === 'layout_type_create' || info.type === 'layout_type_polymeric_create') ? buttonMap['section_top'] : []
    node.maxLength = 4
    node.props.pageType = info.type
    return node
  }
}
// 底部  
export const footer = {
  handle (node, {buttonMap, info}) {
    node.buttons = (info.type === 'layout_type_update' || info.type === 'layout_type_create' || info.type === 'layout_type_polymeric_create') ? buttonMap['section_top'] : []
    node.maxLength = 4
    node.pageType = info.type
    return node
  }
}

// 页面
export const page = {
  handle ({viewComponentName, viewContent}, store) {
    const _viewContent = [
      {
        targetType: 'form',
        elementLinks: viewContent,
        props: {
          span: store?.info?.columns
        }
      }
    ]
    if (store.pageType !== 'list') {
      _viewContent.unshift({
        targetType: 'header'
      })
    }
    if (store.pageType === 'edit') {
      _viewContent.push({
        targetType: 'footer'
      })
    }
    return {
      _type: 'page',
      viewComponentName,
      viewContent: _viewContent
    }
  }
}

// form
export const form = {
  handle (node) {
    return node
  }
}

// tabs
export const tabs = {
  handle (node) {
    node.viewContent = (node.tabs || node.viewContent).map(tab => {
      return {
        info: tab,
        layout: tab.layout,
        targetType: 'tabItem'
      }
    })
    return node
  }
}
